/**
 * Do not edit directly
 * Generated on Fri, 17 Jan 2025 16:09:25 GMT
 */

module.exports = {
  "borderRadius": {
    "1xsmall": "4px",
    "small": "8px",
    "medium": "12px",
    "large": "24px",
    "circle": "50%",
    "pill": "9999px"
  },
  "breakpoints": {
    "1xsmall": "320px",
    "small": "720px",
    "medium": "1080px",
    "large": "1280px",
    "1xlarge": "1600px"
  },
  "color": {
    "primary": {
      "1xsoftest": "#f3f9ff",
      "softest": "#f3f9ff",
      "softer": "#f3f9ff",
      "soft": "#ccdcf8",
      "base": "#0050dc",
      "strong": "#0040b0",
      "stronger": "#002058"
    },
    "accent": {
      "1xsoftest": "#fdf1ea",
      "softest": "#fdf1ea",
      "softer": "#fdf1ea",
      "soft": "#f5cdc6",
      "base": "#e58070",
      "strong": "#dd5a45",
      "stronger": "#9f2f1d"
    },
    "informative": {
      "1xsoftest": "#fce3eb",
      "softest": "#fce3eb",
      "softer": "#fce3eb",
      "soft": "#f1a4c4",
      "base": "#ea78a7",
      "strong": "#e34c8b",
      "stronger": "#821442"
    },
    "alert": {
      "1xsoftest": "#ffeae5",
      "softest": "#ffeae5",
      "softer": "#ffeae5",
      "soft": "#ff9a86",
      "base": "#d23718",
      "strong": "#ab351d",
      "stronger": "#6e0000"
    },
    "notice": {
      "1xsoftest": "#fff3d1",
      "softest": "#fff3d1",
      "softer": "#fff3d1",
      "soft": "#ffce4b",
      "base": "#dda100",
      "strong": "#956e07",
      "stronger": "#6e5001"
    },
    "success": {
      "1xsoftest": "#f3f9ff",
      "softest": "#f3f9ff",
      "softer": "#f3f9ff",
      "soft": "#ccdcf8",
      "base": "#0050dc",
      "strong": "#0040b0",
      "stronger": "#002058"
    },
    "neutral": {
      "1xsoftest": "#f5f5f5",
      "softest": "#ffffff",
      "softer": "#f5f5f5",
      "soft": "#cfcfcf",
      "base": "#616161",
      "strong": "#363232",
      "stronger": "#000000"
    }
  },
  "fontFamily": {
    "brand": "soleil",
    "secondary": "Poppins"
  },
  "fontSize": {
    "2xmini": "11px",
    "1xmini": "12px",
    "mini": "13px",
    "3xsmall": "14px",
    "2xsmall": "15px",
    "1xsmall": "16px",
    "small": "17px",
    "medium": "18px",
    "large": "20px",
    "1xlarge": "22px",
    "2xlarge": "24px",
    "3xlarge": "26px",
    "huge": "28px",
    "1xhuge": "32px",
    "2xhuge": "40px"
  },
  "fontWeight": {
    "regular": "400",
    "bold": "600",
    "1xbold": "700"
  },
  "graphicAndData": {
    "color": {
      "brand1": {
        "softest": "#f3f9ff",
        "softer": "#ccdcf8",
        "soft": "#9fbef4",
        "base": "#0050dc",
        "strong": "#0040b0",
        "stronger": "#002b76"
      },
      "brand2": {
        "softest": "#fdf1ea",
        "softer": "#f5cdc6",
        "soft": "#e58070",
        "base": "#dd5a45",
        "strong": "#ca3b25",
        "stronger": "#9f2f1d"
      },
      "brand3": {
        "softest": "#fce3eb",
        "softer": "#f1a4c4",
        "soft": "#ea78a7",
        "base": "#e34c8b",
        "strong": "#da226e",
        "stronger": "#821442"
      },
      "brand4": {
        "softest": "#f3deff",
        "softer": "#dea5fc",
        "soft": "#cb6dfd",
        "base": "#af38ef",
        "strong": "#6a00a3",
        "stronger": "#460469"
      },
      "brand5": {
        "softest": "#f5f5f5",
        "softer": "#ebebeb",
        "soft": "#cfcfcf",
        "base": "#a1a1a1",
        "strong": "#616161",
        "stronger": "#363232"
      }
    }
  },
  "letterSpacing": {
    "tight": "0px",
    "regular": "1px",
    "loose": "2px"
  },
  "lineHeight": {
    "3xsmall": "12px",
    "2xsmall": "16px",
    "1xsmall": "20px",
    "small": "24px",
    "medium": "28px",
    "large": "32px",
    "1xlarge": "36px",
    "2xlarge": "40px",
    "3xlarge": "44px",
    "huge": "48px",
    "1xhuge": "52px",
    "2xhuge": "56px"
  },
  "opacity": {
    "base": "0.4",
    "strong": "0.8"
  },
  "shadow": {
    "low": "0px 2px 4px rgba(11, 19, 74, 0.08), 0px 4px 8px rgba(11, 19, 74, 0.06), 0px 8px 16px rgba(11, 19, 74, 0.04)",
    "high": "0px 4px 8px rgba(11, 19, 74, 0.1), 0px 8px 16px rgba(11, 19, 74, 0.08), 0px 16px 32px rgba(11, 19, 74, 0.06)",
    "higher": "0px 8px 16px rgba(11, 19, 74, 0.1), 0px 16px 32px rgba(11, 19, 74, 0.08), 0px 32px 64px rgba(11, 19, 74, 0.06)",
    "diffuse": "0px 0px 16px rgba(11, 19, 74, 0.1), 0px 0px 32px rgba(11, 19, 74, 0.08), 0px 0px 64px rgba(11, 19, 74, 0.06)",
    "mobile": {
      "low": {
        "shadow-color": "#0b134a",
        "shadow-offset": "0px 2px",
        "shadow-radius": "3px",
        "shadow-opacity": "0.16",
        "elevation": "2"
      },
      "high": {
        "shadow-color": "#0b134a",
        "shadow-offset": "0px 4px",
        "shadow-radius": "8px",
        "shadow-opacity": "0.16",
        "elevation": "4"
      },
      "higher": {
        "shadow-color": "#0b134a",
        "shadow-offset": "0px 8px",
        "shadow-radius": "16px",
        "shadow-opacity": "0.24",
        "elevation": "8"
      },
      "diffuse": {
        "shadow-color": "#0b134a",
        "shadow-offset": "0px 0px",
        "shadow-radius": "16px",
        "shadow-opacity": "0.24",
        "elevation": "16"
      }
    }
  },
  "spacing": {
    "inline": {
      "none": "0px",
      "3xsmall": "4px",
      "2xsmall": "8px",
      "1xsmall": "12px",
      "small": "16px",
      "medium": "24px",
      "large": "32px",
      "1xlarge": "40px"
    },
    "inset": {
      "2xsmall": "4px",
      "1xsmall": "8px",
      "small": "16px",
      "medium": "24px",
      "large": "32px",
      "1xlarge": "40px",
      "2xlarge": "48px"
    },
    "squishedInset": {
      "1xsmall": "4px 8px",
      "small": "8px 16px",
      "medium": "12px 24px",
      "large": "16px 32px",
      "1xlarge": "24px 48px"
    },
    "stack": {
      "none": "0px",
      "2xsmall": "4px",
      "1xsmall": "8px",
      "small": "16px",
      "medium": "24px",
      "large": "32px",
      "1xlarge": "40px",
      "2xlarge": "48px",
      "3xlarge": "56px",
      "huge": "64px"
    },
    "stretchedInset": {
      "1xsmall": "8px 4px",
      "small": "16px 8px",
      "medium": "24px 12px",
      "large": "32px 16px",
      "1xlarge": "48px 24px"
    }
  },
  "components": {
    "alert": {
      "variation": {
        "neutral": {
          "background": "#f5f5f5",
          "color": "#000000"
        },
        "primary": {
          "background": "#f3f9ff",
          "color": "#002058"
        },
        "info": {
          "background": "#fce3eb",
          "color": "#821442"
        },
        "success": {
          "background": "#f3f9ff",
          "color": "#002058"
        },
        "alert": {
          "background": "#fff3d1",
          "color": "#6e5001"
        },
        "error": {
          "background": "#ffeae5",
          "color": "#6e0000"
        }
      }
    },
    "badge": {
      "svg": {
        "margin": "4px"
      },
      "padding-inline": "8px",
      "font-family": "soleil",
      "font-size": "12px",
      "line-height": "16px",
      "font-weight": "600",
      "radius": {
        "default": "4px",
        "pill": "9999px",
        "dot": "50%"
      },
      "variation": {
        "neutral": {
          "background": "#f5f5f5",
          "color": "#000000"
        },
        "primary": {
          "background": "#f3f9ff",
          "color": "#002058"
        },
        "info": {
          "background": "#fce3eb",
          "color": "#821442"
        },
        "success": {
          "background": "#f3f9ff",
          "color": "#002058"
        },
        "alert": {
          "background": "#fff3d1",
          "color": "#6e5001"
        },
        "error": {
          "background": "#ffeae5",
          "color": "#6e0000"
        }
      },
      "filter": {
        "disabled": {
          "opacity": "0.4"
        },
        "background": "#ffffff",
        "border-color": "#cfcfcf",
        "selected": {
          "background": "#f3f9ff",
          "color": "#0050dc",
          "hover": {
            "background": "#ccdcf8"
          },
          "active": {
            "color": "#002058"
          }
        },
        "hover": {
          "background": "#f5f5f5"
        },
        "active": {
          "background": "#cfcfcf"
        },
        "icon-position": "4px"
      },
      "notification": {
        "variation": {
          "notice": {
            "dot": {
              "background": "#dda100"
            },
            "count": {
              "background": "#fff3d1",
              "color": "#6e5001"
            }
          },
          "alert": {
            "dot": {
              "background": "#d23718"
            },
            "count": {
              "background": "#ffeae5",
              "color": "#6e0000"
            }
          },
          "info": {
            "dot": {
              "background": "#ea78a7"
            },
            "count": {
              "background": "#fce3eb",
              "color": "#821442"
            }
          },
          "primary": {
            "dot": {
              "background": "#0050dc"
            },
            "count": {
              "background": "#f3f9ff",
              "color": "#002058"
            }
          },
          "neutral": {
            "dot": {
              "background": "#616161"
            },
            "count": {
              "background": "#f5f5f5",
              "color": "#000000"
            }
          },
          "accent": {
            "dot": {
              "background": "#0050dc"
            },
            "count": {
              "background": "#f3f9ff",
              "color": "#002058"
            }
          }
        }
      },
      "mobile": {
        "padding": "4px 8px",
        "icon": {
          "spacing": "4px"
        },
        "filter": {
          "color": "#000000",
          "active": {
            "background": "#f5f5f5"
          },
          "selected": {
            "color": "#002058"
          }
        },
        "notification": {
          "spacing": "8px",
          "color": {
            "label": "#000000",
            "dot": "#d23718"
          }
        }
      }
    },
    "button": {
      "default": {
        "font-family": "soleil",
        "font-weight": "600",
        "letter-spacing": "0px",
        "size": {
          "medium": {
            "padding": "12px 24px",
            "font-size": "16px",
            "line-height": "24px",
            "icon-position": "12px"
          },
          "small": {
            "padding": "8px 16px",
            "font-size": "14px",
            "line-height": "20px",
            "icon-position": "8px"
          }
        },
        "radius": "32px",
        "box-shadow": "0px 2px 4px rgba(11, 19, 74, 0.08), 0px 4px 8px rgba(11, 19, 74, 0.06), 0px 8px 16px rgba(11, 19, 74, 0.04)",
        "styles": {
          "primary": {
            "rest": {
              "background-color": "#0050dc",
              "color": "#ffffff",
              "border-width": "",
              "border-style": "",
              "border-color": ""
            },
            "hover": {
              "background-color": "#0040b0",
              "color": "#ffffff",
              "border-width": "",
              "border-style": "",
              "border-color": ""
            },
            "active": {
              "background-color": "#002058",
              "color": "#ffffff",
              "border-width": "",
              "border-style": "",
              "border-color": ""
            }
          },
          "accent": {
            "rest": {
              "background-color": "#e58070",
              "color": "#ffffff",
              "border-width": "",
              "border-style": "",
              "border-color": ""
            },
            "hover": {
              "background-color": "#dd5a45",
              "color": "#ffffff",
              "border-width": "",
              "border-style": "",
              "border-color": ""
            },
            "active": {
              "background-color": "#9f2f1d",
              "color": "#ffffff",
              "border-width": "",
              "border-style": "",
              "border-color": ""
            }
          },
          "secondary": {
            "rest": {
              "background-color": "#ffffff",
              "color": "#000000",
              "border-width": "1px",
              "border-style": "solid",
              "border-color": "#cfcfcf"
            },
            "hover": {
              "background-color": "#f5f5f5",
              "color": "#000000",
              "border-width": "1px",
              "border-style": "solid",
              "border-color": "#cfcfcf"
            },
            "active": {
              "background-color": "#cfcfcf",
              "color": "#000000",
              "border-width": "1px",
              "border-style": "solid",
              "border-color": "#cfcfcf"
            }
          },
          "danger": {
            "rest": {
              "background-color": "#ffffff",
              "color": "#d23718",
              "border-width": "1px",
              "border-style": "solid",
              "border-color": "#ff9a86"
            },
            "hover": {
              "background-color": "#ffeae5",
              "color": "#ab351d",
              "border-width": "1px",
              "border-style": "solid",
              "border-color": "#ff9a86"
            },
            "active": {
              "background-color": "#ff9a86",
              "color": "#6e0000",
              "border-width": "1px",
              "border-style": "solid",
              "border-color": "#ff9a86"
            }
          }
        },
        "disabled": {
          "opacity": "0.4"
        }
      },
      "icon": {
        "size": {
          "height": "48px",
          "width": "48px"
        },
        "radius": "50%",
        "padding": {
          "small": "8px",
          "medium": "12px"
        },
        "styles": {
          "primary": {
            "rest": {
              "background-color": "#ffffff",
              "color": "#0050dc"
            },
            "hover": {
              "background-color": "#f5f5f5",
              "color": "#0050dc"
            },
            "active": {
              "background-color": "#cfcfcf",
              "color": "#0050dc"
            }
          },
          "secondary": {
            "rest": {
              "background-color": "#ffffff",
              "color": "#000000"
            },
            "hover": {
              "background-color": "#f5f5f5",
              "color": "#000000"
            },
            "active": {
              "background-color": "#cfcfcf",
              "color": "#000000"
            }
          }
        }
      },
      "mobile": {
        "size": {
          "medium": {
            "font-size": "15px",
            "line-height": "24px"
          },
          "small": {
            "font-size": "13px",
            "line-height": "20px"
          }
        },
        "icon": {
          "styles": {
            "primary": {
              "background-color": "#f5f5f5",
              "color": "#0050dc"
            },
            "secondary": {
              "background-color": "#f5f5f5",
              "color": "#000000"
            }
          }
        },
        "floating": {
          "position": {
            "bottom": "16px",
            "right": "16px",
            "z-index": "99"
          },
          "styles": {
            "primary": {
              "rest": {
                "background-color": "#0050dc",
                "color": "#ffffff"
              },
              "active": {
                "background-color": "#0040b0"
              }
            },
            "secondary": {
              "rest": {
                "background-color": "#ffffff",
                "color": "#000000"
              },
              "active": {
                "background-color": "#f5f5f5"
              }
            }
          }
        },
        "text": {
          "colors": {
            "rest": "#0050dc",
            "active": "#002058"
          },
          "icon": {
            "spacing": "4px"
          }
        }
      }
    },
    "card": {
      "padding": "24px",
      "border-width": "1px",
      "radius": "12px",
      "background-color": "#ffffff",
      "border-color": "#cfcfcf",
      "variation": {
        "primary": "#f3f9ff",
        "accent": "#fdf1ea",
        "informative": "#fce3eb",
        "alert": "#ffeae5",
        "notice": "#fff3d1",
        "success": "#f3f9ff",
        "neutral": "#f5f5f5"
      },
      "border": {
        "primary": "#ccdcf8",
        "accent": "#f5cdc6",
        "informative": "#f1a4c4",
        "alert": "#ff9a86",
        "notice": "#ffce4b",
        "success": "#ccdcf8",
        "neutral": "#cfcfcf"
      },
      "box-shadow": "0px 2px 4px rgba(11, 19, 74, 0.08), 0px 4px 8px rgba(11, 19, 74, 0.06), 0px 8px 16px rgba(11, 19, 74, 0.04)",
      "footer": {
        "border": {
          "width": "1px",
          "color": "#cfcfcf"
        },
        "gap": "16px",
        "padding": {
          "vertical": "16px",
          "horinzontal": "24px"
        }
      }
    },
    "checkbox": {
      "group": {
        "margin": "4px"
      },
      "radius": "4px",
      "spacing": {
        "inline": "4px",
        "vertical": "8px"
      },
      "background-color": {
        "rest": "#ffffff",
        "hover": "#f5f5f5",
        "focus": "#f5f5f5",
        "active": "#cfcfcf",
        "selected": "#0050dc",
        "indeterminate": "#0050dc",
        "error": "#ffeae5",
        "disabled": "#f5f5f5",
        "readonly": "#f5f5f5",
        "selectedReadonly": "#cfcfcf",
        "selectedDisabled": "#cfcfcf",
        "selectedError": "#d23718",
        "indeterminateDisabled": "#cfcfcf"
      },
      "border-color": {
        "rest": "#cfcfcf",
        "hover": "#cfcfcf",
        "focus": "#363232",
        "active": "#cfcfcf",
        "selected": "#0050dc",
        "indeterminate": "#0050dc",
        "error": "#d23718",
        "disabled": "#cfcfcf",
        "readonly": "#cfcfcf",
        "selectedDisabled": "#cfcfcf",
        "selectedError": "#d23718",
        "indeterminateDisabled": "#cfcfcf"
      },
      "box-shadow": {
        "rest": "none",
        "hover": "0 0 0 8px #f5f5f5",
        "focus": "0 0 0 8px #f5f5f5",
        "active": "0 0 0 8px #f5f5f5"
      },
      "label": {
        "margin": "8px",
        "color": {
          "disabled": "#616161",
          "rest": "#000000"
        }
      },
      "checkmark": {
        "radius": "4px",
        "background": "#ffffff",
        "border": {
          "width": "2px",
          "color": "#cfcfcf"
        },
        "icon": {
          "color": "#ffffff"
        },
        "hover": {
          "background": "#ffffff",
          "border": {
            "width": "2px",
            "color": "#cfcfcf"
          }
        }
      },
      "caption": {
        "color": "#363232"
      }
    },
    "divider": {
      "color": "#cfcfcf",
      "margin-top": "8px",
      "margin-bottom": "8px"
    },
    "drawer": {
      "componentWrapper": {
        "background-color": "#000000A0"
      },
      "closeWrapper": {
        "top": "32px",
        "right": "40px"
      },
      "header": {
        "padding-top": "56px",
        "padding-right": "40px",
        "padding-bottom": "16px",
        "padding-left": "40px"
      },
      "body": {
        "padding-top": "16px",
        "padding-right": "40px",
        "padding-bottom": "32px",
        "padding-left": "40px"
      },
      "container": {
        "border-radius": "12px"
      }
    },
    "dropdown": {
      "content": {
        "width": {
          "default": "280px",
          "subMenu": "240px"
        },
        "padding": "16px",
        "background-color": "#ffffff",
        "radius": "12px",
        "shadow": "0px 4px 8px rgba(11, 19, 74, 0.1), 0px 8px 16px rgba(11, 19, 74, 0.08), 0px 16px 32px rgba(11, 19, 74, 0.06)",
        "margin-top": "8px"
      },
      "item": {
        "caption": {
          "color": "#363232"
        },
        "gap": "16px",
        "background-color": {
          "rest": "#ffffff",
          "hover": "#f5f5f5",
          "active": "#cfcfcf"
        },
        "icon": {
          "color": "#363232"
        },
        "padding": "8px",
        "radius": "4px",
        "color": "#000000",
        "font-family": "soleil",
        "font-size": "18px",
        "font-weight": "400",
        "line-height": "28px"
      },
      "divider": {
        "border-color": "#cfcfcf"
      },
      "backButton": {
        "background-color": "#ffffff",
        "padding-top": "10px",
        "padding-bottom": "10px",
        "margin-bottom": "8px",
        "color": "#0050dc",
        "font-family": "soleil",
        "font-size": "16px",
        "font-weight": "600",
        "line-height": "24px",
        "icon": {
          "margin-right": "8px"
        }
      },
      "mobile": {
        "padding": "24px",
        "overlay": {
          "opacity": "0.4",
          "background-color": "#000000"
        },
        "dialog": {
          "radius": "24px",
          "background-color": "#ffffff"
        },
        "item": {
          "radius": "4px",
          "padding": "8px",
          "background-color": {
            "active": "#f5f5f5"
          }
        }
      }
    },
    "grid": {
      "container": {
        "max-width": "1440px",
        "margin": {
          "xsmall": "16px",
          "small": "32px",
          "medium": "48px",
          "large": "80px",
          "xlarge": "auto"
        }
      },
      "gutter": {
        "small": "16px",
        "medium": "24px"
      }
    },
    "input": {
      "mobile": {
        "font-size": "13px",
        "margin": {
          "label": "4px"
        },
        "font-weight": "600"
      },
      "optionallabel": {
        "color": "#616161",
        "font-size": "16px",
        "font-style": "italic",
        "margin": "8px"
      },
      "padding": "16px",
      "margin": "8px",
      "helper-text": {
        "color": "#363232"
      },
      "border-color": "#cfcfcf",
      "font-family": "soleil",
      "font-size": {
        "desktop": "16px",
        "mobile": "15px"
      },
      "line-height": "24px",
      "color": "#000000",
      "background-color": "#ffffff",
      "radius": "8px",
      "disabled": {
        "background": "#f5f5f5",
        "border-color": "#f5f5f5"
      },
      "focused": {
        "border-color": "#0050dc"
      },
      "placeholder": {
        "color": "#616161"
      },
      "feedback": {
        "error": {
          "border-color": "#d23718"
        }
      },
      "readOnly": {
        "background": "#f5f5f5"
      },
      "suprefix": {
        "margin": "12px",
        "color": "#363232",
        "paragraph": {
          "color": "#616161",
          "line-height": "24px",
          "font-size": "15px"
        },
        "feedback-icon": {
          "margin-left": "12px",
          "error": {
            "color": "#d23718"
          },
          "valid": {
            "color": "#0050dc"
          }
        }
      }
    },
    "link": {
      "font-family": "soleil",
      "line-height": "24px",
      "font-weight": "600",
      "font-size": {
        "medium": "16px",
        "large": "18px"
      },
      "letter-spacing": "0px",
      "radius": "4px",
      "icon": {
        "size": "24px",
        "margin": "12px"
      },
      "colors": {
        "rest": "#0050dc",
        "hover": "#0040b0",
        "focus": "#0040b0",
        "active": "#002058",
        "visited": "#821442"
      }
    },
    "loading": {
      "size": {
        "large": {
          "width": "32px",
          "height": "32px"
        },
        "medium": {
          "width": "24px",
          "height": "24px"
        },
        "small": {
          "width": "16px",
          "height": "16px"
        }
      },
      "variation": {
        "primary": {
          "color": "#0050dc"
        },
        "danger": {
          "color": "#d23718"
        },
        "info": {
          "color": "#ea78a7"
        },
        "notice": {
          "color": "#dda100"
        },
        "success": {
          "color": "#0050dc"
        },
        "neutral": {
          "color": "#616161"
        }
      }
    },
    "modal": {
      "overlay": {
        "background-color": "#000000",
        "opacity": "0.4"
      },
      "dialog": {
        "size": {
          "full": {
            "max-width": "100%"
          },
          "large": {
            "max-width": "864px"
          },
          "small": {
            "max-width": "576px"
          }
        },
        "padding": "32px",
        "margin": "16px",
        "radius": "24px",
        "box-shadow": "0px 8px 16px rgba(11, 19, 74, 0.1), 0px 16px 32px rgba(11, 19, 74, 0.08), 0px 32px 64px rgba(11, 19, 74, 0.06)",
        "background-color": "#ffffff"
      },
      "close": {
        "top": "16px",
        "right": "16px"
      },
      "header": {
        "margin-top": "24px"
      },
      "body": {
        "desktop": {
          "margin-top": "24px"
        },
        "mobile": {
          "margin-top": "16px"
        }
      },
      "footer": {
        "margin-top": "32px"
      },
      "mobile": {
        "padding": "24px"
      }
    },
    "pagination": {
      "button": {
        "size": "48px",
        "border-color": "#cfcfcf",
        "border-radius": "8px",
        "color": {
          "rest": "#000000",
          "selected": "#0050dc"
        },
        "background-color": {
          "rest": "#ffffff",
          "hover": "#f5f5f5",
          "active": "#cfcfcf",
          "selected": "#f3f9ff",
          "disabled": "#ffffff"
        }
      }
    },
    "popover": {
      "variation": {
        "primary": {
          "color": "#ccdcf8"
        },
        "danger": {
          "color": "#ff9a86"
        },
        "info": {
          "color": "#f1a4c4"
        },
        "notice": {
          "color": "#ffce4b"
        },
        "success": {
          "color": "#ccdcf8"
        },
        "neutral": {
          "color": "#cfcfcf"
        }
      }
    },
    "progressbar": {
      "height": "8px",
      "background-color": "#f5f5f5",
      "width": "100%",
      "border-radius": "8px",
      "variation": {
        "primary": {
          "background-color": "#0050dc"
        },
        "success": {
          "background-color": "#0050dc"
        }
      }
    },
    "progresscircle": {
      "size": {
        "small": "32px",
        "medium": "40px",
        "large": "104px"
      },
      "variation": {
        "primary": "#0050dc",
        "success": "#0050dc",
        "danger": "#d23718",
        "info": "#ea78a7",
        "notice": "#dda100",
        "neutral": "#616161"
      }
    },
    "radio": {
      "size": "20px",
      "border-width": "2px",
      "radius": "50%",
      "dot": {
        "size": "8px",
        "background-color": "#ffffff"
      },
      "errorMessage": {
        "color": "#363232"
      },
      "background-color": {
        "rest": "#ffffff",
        "disabled": "#f5f5f5",
        "hover": "#f5f5f5",
        "focus": "#f5f5f5",
        "active": "#cfcfcf",
        "selected": "#0050dc",
        "selectedDisabled": "#cfcfcf",
        "error": "#ffeae5",
        "errorHover": "#ffeae5",
        "errorSelected": "#d23718"
      },
      "border-color": {
        "rest": "#cfcfcf",
        "focus": "#616161",
        "active": "#cfcfcf",
        "selected": "#0050dc",
        "selectedDisabled": "#cfcfcf",
        "error": "#d23718",
        "errorSelected": "#d23718"
      },
      "box-shadow": {
        "disabled": "none",
        "hover": "0 0 0 8px #f5f5f5",
        "focus": "0 0 0 8px #f5f5f5",
        "active": "0 0 0 8px #f5f5f5",
        "errorHover": "0 0 0 8px #f5f5f5"
      },
      "label": {
        "color": {
          "rest": "#000000",
          "disabled": "#616161"
        },
        "font-size": "16px",
        "font-weight": "400",
        "margin-left": "8px"
      }
    },
    "steps": {
      "line": {
        "done": {
          "background-color": "#0050dc"
        },
        "todo": {
          "background-color": "#cfcfcf"
        }
      },
      "wrapper-items": {
        "padding": {
          "left": "8px",
          "right": "16px"
        }
      },
      "done": {
        "bullet": {
          "color": "#0050dc"
        }
      },
      "active": {
        "background-color": "#0050dc",
        "color": "#ffffff",
        "border-radius": "9999px",
        "bullet": {
          "color": "#0050dc"
        }
      },
      "todo": {
        "opacity": 0.6
      },
      "bullet": {
        "background-color": "#ffffff",
        "border-radius": "50%",
        "border-color": "#cfcfcf",
        "etc": {
          "color": "#0050dc"
        }
      }
    },
    "table": {
      "desktop": {
        "radius": "12px",
        "border-width": "1px",
        "border-color": "#cfcfcf",
        "column": {
          "min-width": "120px"
        },
        "heading": {
          "padding": "8px 16px",
          "font-size": "14px",
          "font-weight": "600",
          "line-height": "24px",
          "color": "#000000"
        },
        "cell": {
          "font-size": "16px",
          "font-weight": "400",
          "line-height": "24px",
          "color": "#363232",
          "padding": "8px 16px"
        },
        "detailedContentCell": {
          "padding": "4px 8px"
        },
        "detailedContent": {
          "padding": "12px 24px"
        }
      },
      "mobile": {
        "radius": "12px",
        "border-width": "1px",
        "border-color": "#cfcfcf",
        "cell": {
          "margin-bottom": "16px",
          "color": "#363232"
        },
        "heading": {
          "margin-bottom": "4px"
        },
        "card": {
          "padding": "8px 16px 16px"
        },
        "detailedContent": {
          "padding-top": "16px"
        }
      }
    },
    "text": {
      "color": "#000000",
      "bold": "600",
      "title": {
        "large": {
          "desktop": {
            "fontSize": "40px",
            "lineHeight": "56px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Poppins"
          },
          "mobile": {
            "fontSize": "28px",
            "lineHeight": "36px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Poppins"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "26px",
            "lineHeight": "36px",
            "fontWeight": "600",
            "letterSpacing": "0px",
            "fontFamily": "Poppins"
          },
          "mobile": {
            "fontSize": "20px",
            "lineHeight": "28px",
            "fontWeight": "600",
            "letterSpacing": "0px",
            "fontFamily": "Poppins"
          }
        }
      },
      "sectionHeading": {
        "large": {
          "desktop": {
            "fontSize": "32px",
            "lineHeight": "44px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Poppins"
          },
          "mobile": {
            "fontSize": "24px",
            "lineHeight": "32px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Poppins"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "24px",
            "lineHeight": "32px",
            "fontWeight": "600",
            "letterSpacing": "0px",
            "fontFamily": "Poppins"
          },
          "mobile": {
            "fontSize": "18px",
            "lineHeight": "24px",
            "fontWeight": "600",
            "letterSpacing": "0px",
            "fontFamily": "Poppins"
          }
        }
      },
      "sectionSubheading": {
        "large": {
          "desktop": {
            "fontSize": "26px",
            "lineHeight": "36px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Poppins"
          },
          "mobile": {
            "fontSize": "22px",
            "lineHeight": "28px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Poppins"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "22px",
            "lineHeight": "28px",
            "fontWeight": "600",
            "letterSpacing": "0px",
            "fontFamily": "Poppins"
          },
          "mobile": {
            "fontSize": "16px",
            "lineHeight": "20px",
            "fontWeight": "600",
            "letterSpacing": "0px",
            "fontFamily": "Poppins"
          }
        }
      },
      "detailedSubheading": {
        "large": {
          "desktop": {
            "fontSize": "22px",
            "lineHeight": "28px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Poppins"
          },
          "mobile": {
            "fontSize": "20px",
            "lineHeight": "24px",
            "fontWeight": "700",
            "letterSpacing": "0px",
            "fontFamily": "Poppins"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "20px",
            "lineHeight": "28px",
            "fontWeight": "600",
            "letterSpacing": "0px",
            "fontFamily": "Poppins"
          },
          "mobile": {
            "fontSize": "14px",
            "lineHeight": "20px",
            "fontWeight": "600",
            "letterSpacing": "0px",
            "fontFamily": "Poppins"
          }
        }
      },
      "paragraphLg": {
        "large": {
          "desktop": {
            "fontSize": "24px",
            "lineHeight": "36px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "soleil"
          },
          "mobile": {
            "fontSize": "20px",
            "lineHeight": "28px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "soleil"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "18px",
            "lineHeight": "28px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "soleil"
          },
          "mobile": {
            "fontSize": "17px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "soleil"
          }
        }
      },
      "paragraphMd": {
        "large": {
          "desktop": {
            "fontSize": "18px",
            "lineHeight": "28px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "soleil"
          },
          "mobile": {
            "fontSize": "18px",
            "lineHeight": "28px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "soleil"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "16px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "soleil"
          },
          "mobile": {
            "fontSize": "15px",
            "lineHeight": "20px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "soleil"
          }
        }
      },
      "caption": {
        "large": {
          "desktop": {
            "fontSize": "16px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "soleil"
          },
          "mobile": {
            "fontSize": "16px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "soleil"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "14px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "soleil"
          },
          "mobile": {
            "fontSize": "13px",
            "lineHeight": "20px",
            "fontWeight": "400",
            "letterSpacing": "0px",
            "fontFamily": "soleil"
          }
        }
      },
      "overlineLg": {
        "large": {
          "desktop": {
            "fontSize": "22px",
            "lineHeight": "32px",
            "fontWeight": "400",
            "letterSpacing": "2px",
            "fontFamily": "soleil"
          },
          "mobile": {
            "fontSize": "22px",
            "lineHeight": "32px",
            "fontWeight": "400",
            "letterSpacing": "2px",
            "fontFamily": "soleil"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "16px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "2px",
            "fontFamily": "soleil"
          },
          "mobile": {
            "fontSize": "16px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "2px",
            "fontFamily": "soleil"
          }
        }
      },
      "overlineMd": {
        "large": {
          "desktop": {
            "fontSize": "16px",
            "lineHeight": "24px",
            "fontWeight": "400",
            "letterSpacing": "2px",
            "fontFamily": "soleil"
          },
          "mobile": {
            "fontSize": "18px",
            "lineHeight": "28px",
            "fontWeight": "400",
            "letterSpacing": "2px",
            "fontFamily": "soleil"
          }
        },
        "default": {
          "desktop": {
            "fontSize": "14px",
            "lineHeight": "20px",
            "fontWeight": "400",
            "letterSpacing": "2px",
            "fontFamily": "soleil"
          },
          "mobile": {
            "fontSize": "14px",
            "lineHeight": "20px",
            "fontWeight": "400",
            "letterSpacing": "2px",
            "fontFamily": "soleil"
          }
        }
      }
    },
    "textarea": {
      "mobile": {
        "font-size": "13px",
        "margin": {
          "label": "4px"
        },
        "font-weight": "600"
      },
      "optionallabel": {
        "color": "#616161",
        "font-size": "16px",
        "font-style": "italic",
        "margin": "8px"
      },
      "padding": "16px",
      "margin": "8px",
      "helper-text": {
        "color": "#363232"
      },
      "border-color": "#cfcfcf",
      "font-family": "soleil",
      "font-size": {
        "desktop": "16px",
        "mobile": "15px"
      },
      "line-height": "24px",
      "color": "#000000",
      "background-color": "#ffffff",
      "radius": "8px",
      "disabled": {
        "background": "#f5f5f5",
        "border-color": "#f5f5f5"
      },
      "focused": {
        "border-color": "#0050dc"
      },
      "placeholder": {
        "color": "#616161"
      },
      "feedback": {
        "error": {
          "border-color": "#d23718"
        }
      },
      "readOnly": {
        "background": "#f5f5f5"
      },
      "suprefix": {
        "margin": "12px",
        "color": "#363232",
        "paragraph": {
          "color": "#616161",
          "line-height": "24px",
          "font-size": "15px"
        },
        "feedback-icon": {
          "margin-left": "12px",
          "error": {
            "color": "#d23718"
          },
          "valid": {
            "color": "#0050dc"
          }
        }
      }
    },
    "timeline": {
      "variation": {
        "primary": "#0050dc",
        "danger": "#d23718",
        "info": "#ea78a7",
        "notice": "#dda100",
        "success": "#0050dc",
        "neutral": "#616161"
      },
      "orientation": {
        "vertical": {
          "afterWidth": "1px",
          "afterHeight": "100%",
          "afterTransform": "translateY(-50%) translateX(-0.5px)",
          "justifyBefore": "flex-end",
          "justifyAfter": "flex-start"
        },
        "horizontal": {
          "afterWidth": "100%",
          "afterHeight": "1px",
          "afterTransform": "translate(-50%, 50%)",
          "justifyBefore": "center",
          "justifyAfter": "center"
        }
      }
    },
    "toast": {
      "padding": "16px",
      "border-width": "1px",
      "radius": "8px",
      "background-color": "#ffffff",
      "border-color": "#cfcfcf",
      "variation": {
        "info": "#f3f9ff",
        "alert": "#ffeae5",
        "success": "#f3f9ff"
      },
      "box-shadow": "0px 2px 4px rgba(11, 19, 74, 0.08), 0px 4px 8px rgba(11, 19, 74, 0.06), 0px 8px 16px rgba(11, 19, 74, 0.04)"
    },
    "toggle": {
      "spacing": {
        "inline": "4px"
      },
      "radius": "4px",
      "label": {
        "margin": "16px",
        "color": "#000000",
        "border-color": "#cfcfcf",
        "radius": "9999px",
        "padding": "4px"
      },
      "styles": {
        "success": {
          "checked": {
            "background": "#0050dc"
          }
        },
        "danger": {
          "checked": {
            "background": "#d23718"
          }
        }
      },
      "states": {
        "rest": {
          "background": "#cfcfcf",
          "thumb": {
            "background": "#ffffff",
            "radius": "50%",
            "shadow": "0px 2px 4px rgba(11, 19, 74, 0.08), 0px 4px 8px rgba(11, 19, 74, 0.06), 0px 8px 16px rgba(11, 19, 74, 0.04)"
          }
        },
        "disabled": {
          "color": "#616161",
          "background": "#f5f5f5",
          "thumb": {
            "background": "#cfcfcf"
          }
        }
      },
      "hover": {
        "background": "#f5f5f5"
      },
      "focus": {
        "background": "#f5f5f5"
      }
    },
    "tooltip": {
      "font-family": "soleil",
      "font-size": "16px",
      "line-height": "20px",
      "shadow": "0px 2px 4px rgba(11, 19, 74, 0.08), 0px 4px 8px rgba(11, 19, 74, 0.06), 0px 8px 16px rgba(11, 19, 74, 0.04)",
      "radius": "8px",
      "padding": "8px 16px",
      "max-width": "320px",
      "variations": {
        "default": {
          "background-color": "#002058",
          "color": "#ffffff",
          "extraContentColor": "#cfcfcf",
          "border-color": "transparent"
        },
        "inverted": {
          "background-color": "#ffffff",
          "color": "#000000",
          "extraContentColor": "#616161",
          "border-color": "#cfcfcf"
        }
      }
    }
  },
  "template": {
    "loading": {
      "circle-top-layer-color": "#0050dc"
    }
  }
};